import { useState, useEffect } from 'react';
export type Breakpoints = 'tablet' | 'desktop';
import { breakpoints } from 'themes/helpers';

export type Viewport = 'mobile' | 'tablet' | 'desktop';

// This hook is used to determine the current viewport based on the media query breakpoints
export const useViewport = (): Viewport => {
  const { tablet, desktop } = breakpoints;
  const [viewport, setViewport] = useState<Viewport>('mobile');

  const handleViewport = (screenWidth: number) => {
    if (screenWidth < tablet) {
      setViewport('mobile');
    } else if (screenWidth >= tablet && screenWidth < desktop) {
      setViewport('tablet');
    } else {
      setViewport('desktop');
    }
  };

  useEffect(() => {
    const handleResize = () => {
      handleViewport(window.innerWidth);
    };

    window.addEventListener('resize', handleResize);
    handleResize(); // check size at first render

    // Clean up the event listener when the component unmounts
    return () => {
      window.removeEventListener('resize', handleResize);
    };
  }, []);

  return viewport;
};
